import { IconButton, Tooltip } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, primaryRelationshipColumn, roleColumn, textColumn } from "./columnHelpers";
import { objectDefinition } from "./supportedObjects";
import { formatDate } from "@utils/dates";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { RecordDonationModal } from "@components/RecordDonationModal";
import { CheckPermission } from "@components/CheckPermission";

const {pluralName, color, endpoint} = objectDefinition('donation');

export const donationScopeDonationEntriesRelationship = {
    collapsible: true,
    title: pluralName,
    tint: color,
    type: 'table',
    sort: ['donation_date'],
    columns: [
        dateColumn({label: 'Date' /*'Date Request/Entered'*/, column: 'donation_date'}),
        currencyColumn(),
        textColumn({label: 'Invoice', column: 'invoice_num'}),
        genericColumn({
            label: 'Received',
            render: {
                show: (object, data) => (<>
                    {!!object.received ? formatDate(object.received) : 'No'}

                    <CheckPermission permissions={'edit donations'}>
                    <RecordDonationModal donation={data} entry={object}>
                    {(open, setOpen) => (
                        <Tooltip title={object?.received ? 'Edit Entry' : 'Receive Entry'}>
                            <IconButton
                                color="neutral"
                                variant="outlined"
                                size="sm"
                                sx={{
                                    '--IconButton-size': '1.5rem',
                                    bgcolor: 'background.surface',
                                    verticalAlign: 'sub',
                                    ml: 0.5,
                                    'svg': {
                                        width: '1.05rem',
                                        height: '1.05rem',
                                    }
                                }}
                                onClick={()=>setOpen(true)}
                            >
                                {object.received && (<EditRoundedIcon/>)}
                                {!object.received && (<CheckRoundedIcon/>)}
                            </IconButton>
                        </Tooltip>
                    )}
                    </RecordDonationModal>
                    </CheckPermission>
                </>),
           },
        }),
    ],
};
